<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="ondeliver ? 'show' : 'show'" :style="ondeliver ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-box"></i>
                        </div>
                        <div v-if="data != {}">
                            <h5 class="mb-1">{{ data.type }}{{ data.id }}</h5>
                            <small class="d-block text-xs text-muted">
                                <v-tooltip bottom class="mx-1">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(data.description)">
                                            {{ data.description[0] }} ...
                                        </div>
                                    </template>
                                    <small><div v-for="(description, key) in  data.description" :key="key">{{ description }}</div></small>
                                </v-tooltip>
                            </small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="vstack gap-3">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <v-checkbox v-model="checkbox" color="success" :label="`Pagar`" hide-details></v-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="checkbox">
                                <div class="col-lg-3">
                                    <div class="card cursor-pointer" :class="payment_method == 0 ? 'bg-soft-danger' : ''" @click="payment_method = 0">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg mb-3">
                                                    <i class="bi bi-cash-stack"></i>
                                                </div>
                                                <div>
                                                    <small class="d-block text-xs text-muted">Efectivo</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="card cursor-pointer" :class="payment_method == 1 ? 'bg-soft-danger' : ''" @click="payment_method = 1">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg mb-3">
                                                    <i class="bi bi-credit-card-fill"></i>
                                                </div>
                                                <div>
                                                    <small class="d-block text-xs text-muted">Tarjeta</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="card cursor-pointer" :class="payment_method == 2 ? 'bg-soft-danger' : ''" @click="payment_method = 2">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg mb-3">
                                                    <i class="bi bi-bank"></i>
                                                </div>
                                                <div>
                                                    <small class="d-block text-xs text-muted">Transferencia</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="card cursor-pointer" :class="payment_method == 3 ? 'bg-soft-danger' : ''" @click="() => {
                                        payment_method = 3 
                                        currency = '₡'}">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg mb-3">
                                                    <i class="bi bi-phone-fill"></i>
                                                </div>
                                                <div>
                                                    <small class="d-block text-xs text-muted">Sinpe movil</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-3"></div>
                                <div class="col-lg-6">
                                    <div class="card cursor-pointer" :class="currency == '$' ? 'bg-soft-danger' : payment_method == 3 ? 'bg-light' : ''" @click="payment_method != 3 ? currency = '$' : currency = currency">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg">
                                                    $
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="card cursor-pointer" :class="currency == '₡' ? 'bg-soft-danger' : ''" @click="currency = '₡'">
                                        <div class="card-body">
                                            <div class="d-block text-center">
                                                <div class="icon icon-shape rounded-3 text-dark text-lg">
                                                    ₡
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-3"></div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-body d-flex justify-content-between align-items-center">
                                            <h3 class="text-lg">
                                                <span class="font-weight-light">{{ checkbox ? 'Total' : 'Pendiente'}}: </span>
                                                <span class="font-weight-medium" v-if="currency == '$'"> ${{ Number(data.invoice.total || 0).toFixed(2) }}</span>
                                                <span class="font-weight-medium" v-else> ₡{{ Number((data.invoice.total * exchange_rate) || 0).toFixed(2) }}</span>
                                            </h3>
                                            <button class="btn btn-success px-3" @click="CONFIRM()">
                                                <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                <span v-else>
                                                    {{ checkbox ? 'Entregar / Pago completo' : 'Entregar'}}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: {
        ondeliver: {
            type: Boolean,
        },
        id: {
            type: Number | String
        }
    },
    data () {
        return {
            data: {},
            payment_method: 0,
            currency: '$',
            exchange_rate: 0,
            checkbox: 1,
            count: 0
        }
    },
    created() {
        axios({url: '/drivers/exchange/rate', method: 'GET' })
        .then((resp) => {
            this.exchange_rate = resp.data.US
        })
        
        axios({url: '/packages/' + this.id, method: 'GET' })
        .then((resp) => {
            this.data = resp.data
        })
        .catch((err) => {
            if(err.response.status === 402){
                this.$swal({ toast: true, icon: 'error', title: err.response.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            }else{
                this.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            }
        })
        .finally((resp)=>{
            setTimeout(() => {
                this.$root.spinner = false
            }, 1000)
        })   
    },
    methods: {
        CONFIRM: function(){
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                axios({ url: '/packages/deliver/' + vue.id + '/confirm', method: 'POST', data: { 
                    payment_method: vue.payment_method,
                    currency: vue.currency,
                    exchange_rate: vue.exchange_rate,
                    option: vue.checkbox,
                } })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$emit('onreload')
                        vue.$emit('onclose')
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/modals/Deliver.vue